var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TemplateTable',{attrs:{"name":"retailTransfers","title":_vm.$t('retail.transfers.title'),"url":_vm.$listRoutes.retailTransfers,"filters":_vm.retailTransfersFilters,"table":_vm.retailTransfers,"display-page-back":true,"hide-export":true,"no-cache":true,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }